import React, { FC, CSSProperties } from "react";
import { makeStyles } from "@material-ui/core";
import { Colors } from "../../styles";

const useStyles = makeStyles(() => ({
    container: {
        padding: 24,
        borderRadius: 8,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: Colors.mellowYellow,
        marginTop: 20,
        marginBottom: 20,
        fontSize: 18,
        fontWeight: 200,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: "28px",
        letterSpacing: "normal",

        backgroundColor: Colors.white,
    },
    title: {
        fontSize: 25,
        fontWeight: 500,
        lineHeight: "32px",
        marginBottom: 8,
        color: Colors.mellowYellow,
    },
    text: {
        fontSize: 22,
        fontWeight: 300,
        lineHeight: "1.4",
        color: Colors.anthracite,
    },
}));

type Props = {
    title?: string;
    children: JSX.Element | JSX.Element[];
    style?: CSSProperties;
};

export const InfoBox: FC<Props> = ({ title, children, style }: Props) => {
    const classes = useStyles();

    return (
        <div className={classes.container} style={style}>
            {title && <div className={classes.title}>{title}</div>}
            <div className={classes.text}>{children}</div>
        </div>
    );
};

export const InfoBoxNewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperator: FC =
    () => (
        <InfoBox title="Hinweis">
            <p>
                Rohbauteil mit biegesteifen Rohren wird vorab geliefert und muss bauseits in die
                Bodenplatte eingegossen werden.
            </p>
        </InfoBox>
    );

export const InfoBoxNewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperator: FC =
    () => (
        <InfoBox title="Hinweis">
            <p>Kanalgrundrohre (KG-Rohre) oder andere Kunststoffrohre sind nicht zugelassen.</p>
        </InfoBox>
    );

export const InfoBoxRemovalBuildingOccupation: FC = () => (
    <InfoBox title="Hinweis">
        <p>Zum Zeitpunkt der Demontage darf das Gebäude nicht bewohnt sein.</p>
    </InfoBox>
);

export const InfoBoxRemovalBuildingOccupationDate: FC = () => (
    <InfoBox title="Hinweis">
        <p>
            Zum Zeitpunkt der Demontage darf das Gebäude nicht bewohnt sein. Der Hausanschluss wird
            in der Regel innerhalb von sechs Wochen (im Stadtgebiet Frankfurt drei Monate wegen der
            erforderlichen Aufbruchgenehmigung) demontiert.
        </p>
    </InfoBox>
);

export const InfoBoxRemovalReconstructionApplicationReminder: FC = () => (
    <InfoBox title="Hinweis">
        <p>
            Bitte beantragen Sie Ihren neuen Netzanschluss frühzeitig über das Netzanschluss-Portal.
        </p>
    </InfoBox>
);

export const InfoBoxRemovalPowerSubject: FC = () => (
    <InfoBox title="Hinweis">
        <p>Zur Demontage Ihres Gas-Netzanschlusses sind keine weiteren Angaben erforderlich.</p>
    </InfoBox>
);

export const InfoBoxFutureProof: FC = () => (
    <InfoBox title="Hinweis">
        <p>
            Die Durchführung von Anschlussleitungen durch die Bodenplatte ins Gebäude-innere
            erfordern geeignete Gebäudeeinführungen. Hierfür sind Systeme mit Rohbau- und
            Installationsteil mit einer Gas und Wasserdichtigkeit von mindestens 1 bar, welche
            direkt in die Bodenplatte eingegossen werden geeignet.
        </p>
        <p>
            Für Gaseinführungen sind Bauteile nach DVGW VP 601 erforderlich. Entsprechende
            Eignungsnachweise oder Zertifikate der Bauteile sind bei den Herstellern erhältlich.
            Herkömmliche Leerrohre, z. B. Installationsrohre, Kanalgrundrohre (KG-Rohre) oder
            ähnliche Rohre sowie sonstige Systeme ohne Eignungsnachweis sind für die Haus-einführung
            nicht zugelassen, da keine ausreichende Gewährleistung der Gas- und Wasserdichtigkeit
            von mindestens 1 bar zwischen Rohr und Beton vorhanden ist.
        </p>
        <p>
            Sollte dennoch eine Gebäudeeinführung ohne Eignungsnachweis verwendet werden, kann ein
            Innenraumnetzanschluss nicht realisiert werden. Die hierdurch möglicherweise
            entstehenden Kosten oder Verzögerungen, wie z. B. weitere Anfahrten, Bauzeitverzug,
            Kollision mit anderen Gewerken, o.ä. werden nicht von der Syna getragen.
        </p>
    </InfoBox>
);
